import { Button } from '@/components'
import NavigationPage from '@/app/components/NavigationPage'
import { HomeAddress } from '@/app/features/onboarding/OnboardingQuestionnaire/OnboardingQuestionnaire'
import { ButtonContainer } from '../../ava/BrandedPage'
import { useViewModel } from './useViewModel'

export default function OnboardingAddressSelectPage() {
  const { address, isSubmitting, handleAddressChange, handleSubmit } =
    useViewModel()

  return (
    <NavigationPage id="onboarding-address-select" navigationOptions={['back']}>
      <NavigationPage.SingleCardContent>
        <HomeAddress onChange={handleAddressChange} isLoading={isSubmitting} />
        <ButtonContainer>
          <Button
            id="submit-button"
            variant="primary"
            disabled={!address || isSubmitting}
            onClick={handleSubmit}
            className="w-full"
          >
            {isSubmitting ? 'Loading...' : 'Next'}
          </Button>
        </ButtonContainer>
      </NavigationPage.SingleCardContent>
    </NavigationPage>
  )
}
